<template>
  <div style="height: 100%;overflow-y: auto !important;display: ">
    <div class="terms-container">
      <!-- <h2>利用規約</h2>
      <div class="terms-box">
        <p v-html="linkedTermsMsg"></p>
      </div>-->
      <h2>利用規約</h2>
      <div class="terms-box">
        <p class="terms-text">
          <template v-for="(part, index) in parts" :key="index">
            <a
              v-if="part.type === 'link'"
              :href="part.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ part.text }}
            </a>
            <span v-else>
              {{ part.text }}
            </span>
          </template>
        </p>
      </div>
    </div>
    <v-row justify="center" no-gutters>
      <v-col cols="auto">
        <v-checkbox
          v-model="agreed"
          label="利用規約に同意します"
          color="blue"
        />
      </v-col>
    </v-row>
    <v-container>
      <v-btn @click="backFnc" color="grey darken-2">
        戻る
      </v-btn>
      &nbsp;&nbsp;
      <v-btn :disabled="!agreed" @click="start" color="blue">
        同意して進む
      </v-btn>
    </v-container>
  </div>
</template>
<script>
// import axios from 'axios'
// import { ref, computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
export default {
  data () {
    return {
      code: '',
      // termsMsg: '',
      linkedTermsMsg: '',
      parts: [],
      agreed: false
    }
  },
  mounted () {
    // alert('terms')
    const auth = useAuthStore()
    auth.setBsw('0') // 戻るボタン制御用
    // alert('terms1')
    // alert('terms' + auth.token)
    if (auth.token !== 'ok') {
      auth.setBsw('1') // 戻るボタン制御用
      this.$router.push('/')
    } else {
      this.parts = this.splitTextWithLinks(auth.termstext)
    }
    // alert('terms3')
  },
  methods: {
    start () {
      // alert('terms next0')
      const auth = useAuthStore()
      auth.setAcceptFlg('1')
      // 値の保存(common.js)
      // alert('terms next1')
      auth.setBsw('1') // 戻るボタン制御用
      // 確保してあるデータの初期化 リージョン 選択された製品
      auth.setRegion('')
      auth.clearnewProducts()
      const initYmd = this.getFormattedDateTime()
      auth.setInitymd(initYmd)
      // alert('terms next2')
      // window.currentId = '/region'
      this.$router.push('/region')
    },
    getFormattedDateTime () {
      const now = new Date()
      const yyyy = now.getFullYear()
      const mm = String(now.getMonth() + 1).padStart(2, '0') // 月は0始まり！
      const dd = String(now.getDate()).padStart(2, '0')
      const hh = String(now.getHours()).padStart(2, '0')
      const min = String(now.getMinutes()).padStart(2, '0')
      const ss = String(now.getSeconds()).padStart(2, '0')
      return `${yyyy}${mm}${dd}${hh}${min}${ss}`
    },
    async backFnc () {
      const auth = useAuthStore()
      auth.setBsw('1') // 戻るボタン制御用
      this.$router.push('/home')
    },
    splitTextWithLinks (text) {
      const urlRegex = /(https:\/\/[^\s）]+)/g
      const result = []
      let lastIndex = 0
      const src = text || ''
      for (const match of src.matchAll(urlRegex)) {
        const start = match.index
        const url = match[0]
        // URL前のテキスト
        if (start > lastIndex) {
          result.push({
            type: 'text',
            text: src.slice(lastIndex, start)
          })
        }
        // リンク部分
        result.push({
          type: 'link',
          text: url,
          url
        })
        lastIndex = start + url.length
      }
      // 残りのテキスト
      if (lastIndex < src.length) {
        result.push({
          type: 'text',
          text: src.slice(lastIndex)
        })
      }
      return result
    }
  }
}
</script>
<style scoped>
.terms-container {
  max-width: 1080px;
  margin: auto;
  padding: 1rem;
}
.terms-box {
  text-align: left;
  white-space: pre-wrap;
  height: 355px;
  overflow-y: scroll;
  border: 1px solid #ccc;
  padding: 1rem;
  margin-bottom: 1rem;
  background-color: #f9f9f9;
}
button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
<style scoped>
.terms-text {
  white-space: pre-wrap;
  line-height: 1.4;
}
</style>
